<template>
  <qx-card title="ETC卡充值记录列表">
    <LogRightDialog ref="logRightDialog" busiCode="22000054" />
    <RechargeAudit ref="rechargeAudit" @success="reloadData" />
    <section slot="titleRight">
      <qx-permpisions permpisions="4000905">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="etcEntityBO.ajax?cmd=queryEtcEntityPage"
          :params="fullSearchData"
          bizName="ETC卡充值记录"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'orderId'">
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-if="scope.column.property !== 'orderId'">
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1005040401',
                    showCondition: scope.row.rechargeState === 1 && scope.row.audit ==true,
                    name: '审核',
                    event: () => toVerify(scope.row),
                  },
                  {
                    permpisions: '1005040403',
                    showCondition: scope.row.rechargeState === 1,
                    name: '取消',
                    event: () => cancel(scope.row.id),
                  },
                  {
                    permpisions: '1005040402',
                    showCondition: scope.row.rechargeStateName === '待核销',
                    name: '核销',
                    event: () => toCancel(scope.row.id),
                  },
                  {
                    name: '日志',
                    event: () => showLog(scope.row.id),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import LogRightDialog from 'components/logRightDialog';
import RechargeAudit from './rechargeAudit';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  queryEtcEntityPage,
  revokeEtcCharge,
  batchVerificationEtc,

} from 'api/service';
import {driverArchivesDel} from 'api/archives';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableBtn,
    LogRightDialog,
    RechargeAudit,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'etcRechargeId', label: '申请单号', fixed: true },
          { prop: 'etcCardNum', label: 'ETC卡号' },
          { prop: 'etcCardTypeName', label: '卡类型' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'serviceName', label: '服务商' },
          { prop: 'rechargeAmount', label: '充值金额' },
          { prop: 'etcBalance', label: '充值前余额' },
          { prop: 'applyUserName', label: '申请人' },
          { prop: 'applyTime', label: '申请时间' },
          { prop: 'rechargeStateName', label: '状态' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryEtcEntityPage,
    reloadData () {
      this.getData();
    },
    toVerify (item) {
      this.$refs.rechargeAudit.show(item);
    },
    async cancel (id) {
      const confirmRes = await this.$confirm('是否确定取消充值？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const delRes = await revokeEtcCharge({
          id,
        });
        if (!delRes.failed) {
          this.$message({
            type: 'success',
            message: '已成功取消',
          });
          this.getData();
        }
      }
    },
    showLog (etcRechargeId) {
      this.$refs.logRightDialog.show(etcRechargeId);
    },
    async toCancel (id) {
      const confirmRes = await this.$confirm('是否确认核销', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消核销
        this.$message({
          type: 'info',
          message: '已取消核销',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await batchVerificationEtc({
          ids: id,
        });
        if (!res.failed) {
          this.$message.success('核销成功');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
